import React, { PureComponent } from 'react';
import { ambient } from '@aw_products/ambient-weather-common'
import bindAllActions from '../../common/bindAllActions'
import PropTypes from 'prop-types';
import { path, pluck, uniq, filter, propEq, find, map, toPairs, values, pipe, prop, groupBy } from 'ramda'
import { getLabelForDevice, getDeviceLabel, sortByDateDesc, isLoggedIn, fmtzDate, shouldGetDevice, timeFormatForUser } from '../../common/ambient'
import FormattedDataPoint from '../device/FormattedDataPoint'
import classNames from 'classnames'
import {
  Loader,
  FromNow
} from '../../components'
import { TIME_ALERT_PARAM } from '../alert'

class Instances extends PureComponent {
  static propTypes = {
    alertActions: PropTypes.object.isRequired,
    alert: PropTypes.object.isRequired,
    device: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
    user: PropTypes.object,
  };
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      first: false
    }
    this.nextPage = ::this.nextPage
  }
  componentDidMount() {
    const { user } = this.props
    if (isLoggedIn(user) && !this.state.first) {
      this.nextPage()
    }
  }
  componentDidUpdate() {
    const { user, alert, alertActions } = this.props 
    const { alertSets, fetchAlertSetsPending } = alert
    if (isLoggedIn(user) && !this.state.first) {
      this.nextPage()
    }
    if (isLoggedIn(user) && !alertSets && !fetchAlertSetsPending) {
      alertActions.fetchAlertSets({
        userId: user.info._id
      })
    }
  }
  nextPage() {
    const { page, first } = this.state
    const { deviceActions, device, user, alert, alertActions } = this.props 
    const { fetchInstancesPagination } = alert
    if (!first) {
      this.setState({
        first: true
      })
    }
    const opts = {
      userId: user.info._id,
      $sort: { createdAt: -1 }
    }
    if (page > 1) {
      opts.$skip = fetchInstancesPagination.limit * (page - 1)
    }
    alertActions.fetchInstances(opts)
      .then(() => {
        const { alertInstances } = alert
        pipe(
         pluck('deviceId'),
         uniq,
         filter(deviceId => shouldGetDevice(device, deviceId)),
         map(deviceId => deviceActions.getDevice(deviceId))
        )(alertInstances)
      })

  }

  render() {
    const { alert, device, user } = this.props
    const { fetchInstancesPending, alertInstances, fetchInstancesPagination, alertSets = [] } = alert
    const { deviceCache } = device
    let content = ''
    function instanceDiv(ai) {
      let closed = ''
      let theLabel = ''
      let theValue = ''
      let extra = ''
      let theDevice, deviceLine
      const isAlertSet = !!ai.origAlert.alertSetId
      const alertSet = find(propEq('_id', ai.origAlert.alertSetId), alertSets)
      if (device.devices && device.devices.length > 0) {
        theDevice = find(propEq('_id', ai.deviceId), device.devices)
        // if it's not our own device
        if (!theDevice) {
          theDevice = deviceCache[ai.deviceId]
        }
        deviceLine = <div className="device">{alertSet && alertSet.title} {getDeviceLabel(theDevice)}</div>
      }
      if (/^leak/.test(ai.origAlert.param)) {
        theLabel = <span>
          {ai.origAlert.threshold === 1 ? ' Leak Detected' : ' Leak Sensor Offline'}
        </span>
      } else if (ai.origAlert.param === TIME_ALERT_PARAM) {
        // For time alerts, theLabel will be empty, title will show the name
        theLabel = null
        theValue = ai.origAlert.data && ai.origAlert.data.message ? ai.origAlert.data.message : ''
      } else if (ai.origAlert.param !== 'notReporting') {
        // Heat Stress
        if (ai.alertId === ambient.HST.ALERT_ID) {
          const zone = ai.origAlert.zone
          theLabel = (
            <span>
              &nbsp;
              {ai.origAlert.guideline.name} - {path(['label'], zone)}
            </span>
          )
          // extra = (
          //   <p>{zone.label}</p>
          // )
        } else {
          theLabel = <span>
            {ai.origAlert.condition === '>' ? ' over ' : ' under '}
            <FormattedDataPoint value={ai.origAlert.threshold} type={ai.origAlert.param} />
          </span>
        }
        theValue = <FormattedDataPoint value={ai.data[ai.origAlert.param]} type={ai.origAlert.param} />
        if (ai.closed) {
          closed += ', '
        }
      }
      if (ai.closed) {
        closed += 'Lasted for ' + moment.duration(moment(ai.closed).diff(ai.createdAt, 'minutes'), 'minutes').humanize()
      }
      let title = ai.origAlert.param === TIME_ALERT_PARAM 
        ? (ai.origAlert.data && ai.origAlert.data.name ? ai.origAlert.data.name : 'Time-based Alert')
        : getLabelForDevice(ai.origAlert.param, theDevice)
      
      const isTimeAlert = ai.origAlert.param === TIME_ALERT_PARAM
      
      return (
        <div className={classNames('instance', { 'alert-set': isAlertSet, 'time-alert': isTimeAlert }, alertSet && alertSet.type)} key={ai._id}>
          <div className="time">
            {!isTimeAlert ? fmtzDate(timeFormatForUser(user), ai.createdAt) : ''}
          </div>
          <div className="info">
            <i className={classNames('glyphicon', {
              'glyphicon-user': !isAlertSet,
              'glyphicon-team-alerts': isAlertSet
            })} />
            {deviceLine}
            <b>
              {title}
              {theLabel}
              {ai.ifttt ? <i className="ifttt" title="This alert was create on IFTTT" /> : ''}
            </b>
            {extra}
            <p>
              {theValue}
              {closed}
            </p>
          </div>
          <FromNow dateutc={ai.createdAt} />
        </div>
      )
    }
    const format = 'dddd, MM/DD/YYYY'
    const groupedInstances = groupBy(pipe(prop('createdAt'), fmtzDate(format)), alertInstances)
    content = pipe(
      toPairs,
      map((arr) => {
        const date = arr[0]
        const ais = arr[1]
        return (
          <div key={date + ais.length} className="group">
            <div className="date">{date}</div>
            {ais
              .sort((a, b) => (new Date(b.createdAt) - new Date(a.createdAt)))
              .map(instanceDiv)
            }
          </div>
        )
      }),
      values
    )(groupedInstances)
    if (fetchInstancesPending) {
      content.push(<Loader key={'loader'} />)

    } else if (fetchInstancesPagination && alertInstances.length < fetchInstancesPagination.total) {
      content.push(
        <a
          key={'all'}
          className="more"
          onClick={()  => {
            this.setState({
              page: this.state.page + 1
            }, this.nextPage)
          }}
        >
          See More
          <i className="glyphicon glyphicon-chevron-down" />
        </a>
      )
    }
    if (alertInstances.length < 1) {
      return <div />
    }
    return (
      <div className="alert-instances v2">
        {content}
      </div>
    );
  }
}
export default bindAllActions(Instances)

Instances.displayName = 'Instances'
